export default __webpack_public_path__ + "static/media/realRoom.9f06cac4.jpeg";